import { createSlice } from "@reduxjs/toolkit";
import { signinApi } from "../signin/signinApi";
import { sellerApi } from "../seller/sellerApi";
import { reducerPaths } from "../../app/reducerPaths";
import { revertAll } from "../../app/revertAll";

const initialState = {
  isNewUser: false,
  user_id: null,
  user_name: "",
  token: null,
  userData: null,
  isUserDataLoading: false
};

const authReducer = createSlice({
  name: reducerPaths.auth,
  initialState,
  reducers: {
    setAuthAction: (state, action) => {
      for (let i = 0; i < Object.entries(action?.payload)?.length; i++) {
        state[Object.entries(action?.payload)?.[i]?.[0]] = Object.entries(
          action?.payload
        )?.[i]?.[1];
      }
    },
    setSignoutAction: (state, action) => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(revertAll, () => initialState);
    builder.addMatcher(
      signinApi.endpoints.verifyOtpHandler.matchFulfilled,
      (state, { payload }) => {
        if (payload?.UserID) {
          state.user_id = payload.UserID;
          state.token = payload.token;
        }
      }
    );
    builder.addMatcher(
      sellerApi.endpoints.getSellerProfile.matchPending,
      (state, { payload }) => {
        state.isUserDataLoading = true;
      }
    );
    builder.addMatcher(
      sellerApi.endpoints.getSellerProfile.matchRejected,
      (state, { payload }) => {
        state.isUserDataLoading = false;
      }
    );
    builder.addMatcher(
      sellerApi.endpoints.getSellerProfile.matchFulfilled,
      (state, { payload }) => {
        state.isUserDataLoading = false;
        console.log('Profile_details:', payload);
        if (payload?.status) {
          state.userData = payload?.data;
        }
      }
    );
  },
});

export const { 
  setAuthAction,
  setSignoutAction
} = authReducer.actions;

export default authReducer.reducer;
